import './api';
import store from './store';
import history from './history';

export default {
    store,
    history
};
